import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import GetCurrentUserService from '../../user/Services/GetCurrentUserService.js'
import {GetMatchesUserAlertsError} from '../Errors/GetMatchesUserAlertsError.js'
import HTTPUserAlertsRepository from '../Repositories/HTTPUserAlertsRepository.js'

class GetMatchesUserAlertsUseCase extends UseCase {
  #repository
  #service

  #handleError(error) {
    if (GetMatchesUserAlertsError.isGetMatchesUserAlertsError({error})) return Promise.reject(error)
    return Promise.reject(GetMatchesUserAlertsError.createGenericError({cause: error}))
  }

  constructor({repository, service}) {
    super()
    this.#repository = repository
    this.#service = service
  }

  static create({config}) {
    return new GetMatchesUserAlertsUseCase({
      repository: HTTPUserAlertsRepository.create({config}),
      service: GetCurrentUserService.create({config})
    })
  }

  @tracer({metric: 'GetMatchesUserAlertsUseCase#execute'})
  @AsyncInlineError()
  async execute({alertId, search = {}} = {}) {
    try {
      if (!alertId) throw GetMatchesUserAlertsError.createInvalidParametersError()

      const userEntity = await this.#service.execute()

      if (!userEntity) throw GetMatchesUserAlertsError.createNotAuthenticatedError()

      const [error, response] = await this.#repository.getMatchesByAlertId({
        alertId,
        userId: userEntity.getId(),
        search
      })

      return error ? this.#handleError(error) : response
    } catch (error) {
      return this.#handleError(error)
    }
  }
}

export const factory = GetMatchesUserAlertsUseCase.create
